import { SvgIcon, SvgIconProps } from '@mui/material';

const InfoPopUpIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.01 2c-1.092 0-2 .905-2 1.998L2 22l4-4h14c1.093 0 2-.907 2-2V4c0-1.093-.907-2-2-2H4.01Zm0 2H20v12H5.172l-1.168 1.168L4.01 4ZM11 6v2h2V6h-2Zm0 4v4h2v-4h-2Z"
    />
  </SvgIcon>
);
export default InfoPopUpIcon;
